import { c as _c } from "react/compiler-runtime";
import { isEmpty } from 'lodash';
import getVisitorLocationQueryVariables from 'commons/getVisitorLocationQueryVariables';
import useUserLocation from 'global-state/userLocation/useUserLocation';
import usePDPApolloQueryVariables from '../usePDPApolloQueryVariables';
import getNonPDPQueryVariables from './getNonPDPQueryVariables';
const useProductBasicQueryOptions = t0 => {
  const $ = _c(7);
  const {
    id,
    slug,
    queryOptions,
    hookOptions
  } = t0;
  const {
    skipPDPStateHook: t1,
    delayLoad: t2,
    productSku: t3,
    regionId
  } = queryOptions;
  const skipPDPStateHook = t1 === undefined ? false : t1;
  const delayLoad = t2 === undefined ? false : t2;
  const productSku = t3 === undefined ? "" : t3;
  const {
    skip: t4
  } = hookOptions;
  const skip = t4 === undefined ? false : t4;
  const finalNonPDPQueryVariables = skipPDPStateHook ? getNonPDPQueryVariables(id, productSku, hookOptions) : {};
  const userLocation = useUserLocation();
  const locationVars = getVisitorLocationQueryVariables(userLocation?.stateShortName, regionId);
  let t5;
  if ($[0] !== skipPDPStateHook) {
    t5 = {
      skip: skipPDPStateHook
    };
    $[0] = skipPDPStateHook;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  const {
    variables,
    skip: skipPdpQuery
  } = usePDPApolloQueryVariables(id, slug, t5);
  const skipPdpVariableQuery = productSku && skipPdpQuery ? false : skipPdpQuery;
  const t6 = skipPDPStateHook ? {
    ...finalNonPDPQueryVariables,
    ...locationVars
  } : {
    ...variables,
    ...locationVars
  };
  const t7 = skip || skipPdpVariableQuery || delayLoad || skipPDPStateHook && isEmpty(finalNonPDPQueryVariables);
  let t8;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      noBatch: true
    };
    $[2] = t8;
  } else {
    t8 = $[2];
  }
  const t9 = queryOptions?.ssr ?? true;
  let t10;
  if ($[3] !== t6 || $[4] !== t7 || $[5] !== t9) {
    t10 = {
      variables: t6,
      skip: t7,
      context: t8,
      ssr: t9
    };
    $[3] = t6;
    $[4] = t7;
    $[5] = t9;
    $[6] = t10;
  } else {
    t10 = $[6];
  }
  return t10;
};
export default useProductBasicQueryOptions;